import { STEP, ACCOUNT_CREATION_ERROR_MESSAGE } from '~/constants/checkout';
import { CheckoutStepProps, SetStepErrorMessageType } from '~/types/checkout';
import { FacebookLoginResponseProps, SessionHelperProps } from '~/types/user';
import { CredentialResponse } from '@react-oauth/google';

export const fbLoginFunction = (
  response: FacebookLoginResponseProps,
  isSubmittingAccount: boolean,
  setStepErrorMessage: SetStepErrorMessageType,
  setIsSubmittingAccount: (isSubmittingAccount: boolean) => void,
  facebookSignIn: (
    response: FacebookLoginResponseProps,
    callback: (asyncSessionData: () => Promise<SessionHelperProps>) => void,
  ) => void,
  mutateItems: () => void,
  setStep: (step: CheckoutStepProps) => void,
) => {
  if (isSubmittingAccount) {
    setStepErrorMessage(STEP.ACCOUNT, ACCOUNT_CREATION_ERROR_MESSAGE);
    return;
  }

  setIsSubmittingAccount(true);

  // This will return an error if there is no session, no need to check for the session again
  facebookSignIn(response, async (asyncSessionData: any) => {
    const { error } = await asyncSessionData();

    if (error) {
      setStepErrorMessage(STEP.ACCOUNT, error);
      setIsSubmittingAccount(false);
      return;
    }

    mutateItems();
    setStep(STEP.BILLING);
    setIsSubmittingAccount(false);
  });
};

export const handleGoogleLogin = async (
  credentialResponse: CredentialResponse,
  isSubmittingAccount: boolean,
  setStepErrorMessage: SetStepErrorMessageType,
  setIsSubmittingAccount: (isSubmittingAccount: boolean) => void,
  googleSignIn: (response: CredentialResponse) => Promise<SessionHelperProps>,
  mutateItems: () => void,
  setStep: (step: CheckoutStepProps) => void,
) => {
  if (isSubmittingAccount) {
    setStepErrorMessage(STEP.ACCOUNT, ACCOUNT_CREATION_ERROR_MESSAGE);
    return;
  }

  setIsSubmittingAccount(true);

  // This will return an error if there is no session, no need to check for the session again
  const { error } = await googleSignIn(credentialResponse);

  if (error) {
    setStepErrorMessage(STEP.ACCOUNT, error);
    setIsSubmittingAccount(false);
    return;
  }

  mutateItems();
  setStep(STEP.BILLING);
  setIsSubmittingAccount(false);
};
